module.exports = __webpack_public_path__ + "static/media/mz.bc33186e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mz.svg
// module id = 204
// module chunks = 0